import React from "react";

function RegionalCampaigns() {
  return (
    <svg
      width="22"
      height="19"
      viewBox="10 10 20 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M24.25 10.75V25.25H23.3105L19.3105 21.25H16.25V26.25H15C14.3142 26.25 13.75 25.6858 13.75 25V21.25H12C11.3142 21.25 10.75 20.6858 10.75 20V16C10.75 15.3142 11.3142 14.75 12 14.75H19.3105L23.3105 10.75H24.25ZM27.75 15.8701C28.6426 16.1646 29.25 16.9801 29.25 18C29.25 19.0198 28.6425 19.8343 27.75 20.1289V15.8701Z"
        stroke="#667085"
        strokeWidth="1.5"
      />
    </svg>
  );
}

export default RegionalCampaigns;
